import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseDuration'
})
export class ParseDurationPipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    let hours: any = Math.floor(value / 3600);
    if (hours < 10) hours = '0' + hours;
    let minutes: any = Math.floor((value % 3600) / 60);
    if(minutes < 10) minutes = '0' + minutes;
    return hours + 'h' + minutes;
  }

}
